import React from 'react';
import { Modal } from 'react-bootstrap';
import StockItemDetailsScreen from '../../../screens/StockItemDetailsScreen';

const StockItemModal = ({ show, handleClose, handleStockItemCreated }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Create New Stock Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StockItemDetailsScreen
                    onStockItemCreated={handleStockItemCreated}
                    onCancel={handleClose}
                    isModal={true}
                />
            </Modal.Body>
        </Modal>
    );
};

export default StockItemModal; 